export default __webpack_public_path__ + "static/media/pq_1.56d62bf3.jpg";